import { request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";
export const getTeacherCourseList = (params) =>
  request(`/v1/teacherCourse/getList`, "get", {
    params,
  });
export const getUserToken = (params) =>
  request(`/v1/userCourse/getUserToken`, "get", {
    params,
  });

export const getTeacherToken = (params) =>
  request(`/v1/teacherCourse/getUserToken`, "get", {
    params,
  });
export const createRoomByMode = (params) =>
  request(`${mock}/v1/teacherCourse/createRoomByMode`, "POST", {
    json: params,
  });
// 获取直播数据统计
export const getLiveSta = (params) =>
  request(`/v1/course/live/statistics`, "get", {
    params,
  });
// 使用示例
// import { getTeacherCourseList, getUserToken } from "@saas/service-api/src/live-list";
